import "react";
import { jsx as e } from "react/jsx-runtime";
import { ILL_ENTER as t } from "@maat/assets";
//#region src/components/Illustration/renderIllNode.tsx
var n = (e) => {
	let n = {};
	if (e.enter) {
		let { preset: r, at: i, dur: a } = e.enter;
		n["--t"] = `${i}ms`, a !== void 0 && a !== t[r].dur && (n["--d"] = `${a}ms`);
	}
	return e.origin && (n.transformOrigin = `${e.origin[0]}px ${e.origin[1]}px`), Object.keys(n).length ? n : void 0;
}, r = (e) => typeof e == "object" ? e.join(" ") : e, i = (e) => ({
	fill: e.fill,
	opacity: e.opacity,
	transform: e.transform,
	stroke: e.stroke,
	strokeWidth: e.strokeWidth,
	strokeLinecap: e.strokeLinecap,
	strokeLinejoin: e.strokeLinejoin,
	strokeDasharray: r(e.strokeDasharray),
	strokeDashoffset: e.strokeDashoffset,
	className: [e.enter && `p-${e.enter.preset}`, e.anim && `a-${e.anim}`].filter(Boolean).join(" ") || void 0,
	style: n(e)
}), a = (t, n) => {
	let r = {
		key: n,
		...i(t)
	};
	switch (t.kind) {
		case "path": return /* @__PURE__ */ e("path", {
			...r,
			d: t.d
		});
		case "rect": return /* @__PURE__ */ e("rect", {
			...r,
			x: t.x,
			y: t.y,
			width: t.width,
			height: t.height,
			rx: t.rx
		});
		case "circle": return /* @__PURE__ */ e("circle", {
			...r,
			cx: t.cx,
			cy: t.cy,
			r: t.r
		});
		case "ellipse": return /* @__PURE__ */ e("ellipse", {
			...r,
			cx: t.cx,
			cy: t.cy,
			rx: t.rx,
			ry: t.ry
		});
		case "g": return /* @__PURE__ */ e("g", {
			...r,
			children: t.children.map(a)
		});
		default: return null;
	}
};
//#endregion
export { a as renderIllNode };
